import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import Show from 'components/Show';
import Icon from 'components/Misc/Icon';

const Button = ({ submit, value, icon, small, square, theme, disabled, className, iconClassName, onClick, to, outside, download }) => {
	// Button's className
	const cls = classnames(
		'inline-flex space-x-2 justify-center items-center rounded-lg text-sm font-semibold cursor-pointer transition-colors',
		(!square && !small) && 'px-4',
		(!square && small) && 'px-2',
		small ? 'h-7' : 'h-10',
		(small && square) && 'w-7',
		(!small && square) && 'w-10',
		!theme && 'text-neutral-700 bg-neutral-100 hover:bg-neutral-200 dark:text-white dark:bg-neutral-800 dark:hover:bg-neutral-700',
		theme === 'darker' && 'text-neutral-700 bg-neutral-200 hover:bg-neutral-300 dark:text-white dark:bg-neutral-700 dark:hover:bg-neutral-600',
		theme === 'primary' && 'text-white bg-amber-500 hover:bg-amber-400',
		theme === 'success' && 'text-white bg-emerald-500 hover:bg-emerald-400',
		theme === 'danger' && 'text-white bg-rose-500 hover:bg-rose-400',
		theme === 'transparent' && 'text-neutral-700 hover:bg-neutral-100 dark:text-neutral-100 dark:hover:bg-neutral-800',
		className
	);

	// Icon's className
	const iconCls = classnames(
		'text-xl',
		small && 'text-base',
		!iconClassName && 'font-normal',
		iconClassName
	);

	// Return a tag link to outside source
	if (outside) {
		return (
			<a
				rel="noreferrer"
				target="_blank"
				href={outside}
				download={download}
				disabled={disabled}
				className={cls}
			>
				{/* Show icon if given */}
				<Show if={icon}>
					<Icon icon={icon} className={iconCls} />
				</Show>

				{/* Show value if given */}
				<Show if={value}>
					<span>
						{value}
					</span>
				</Show>
			</a>
		);
	}

	// Return Link button
	if (to) {
		return (
			<Link
				to={to}
				onClick={onClick}
				disabled={disabled}
				className={cls}
			>
				{/* Show icon if given */}
				<Show if={icon}>
					<Icon icon={icon} className={iconCls} />
				</Show>

				{/* Show value if given */}
				<Show if={value}>
					<span>
						{value}
					</span>
				</Show>
			</Link>
		);
	}

	// Return default button with onClick handler
	return (
		<button
			type={submit ? 'submit' : 'button'}
			onClick={onClick}
			disabled={disabled}
			className={cls}
		>
			{/* Show icon if given */}
			<Show if={icon}>
				<Icon icon={icon} className={iconCls} />
			</Show>

			{/* Show value if given */}
			<Show if={value}>
				<span>
					{value}
				</span>
			</Show>
		</button>
	);
};

export default Button;